import type { SVGProps } from "react";
const SvgDone = (props: SVGProps<SVGSVGElement>) => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <rect x="3" y="7" width="10" height="2" rx="1" fill="#8E8E8E"/>
</svg>
);
export default SvgDone;